import { observer } from 'mobx-react-lite'
import styles from './ConsolidatedTimeSlotList.module.css'

export const ConsolidatedTimeSlotGroup = observer(
  function ConsolidatedTimeSlotGroup({
    header,
    children,
  }: {
    header: string
    children: React.ReactNode
  }) {
    return (
      <>
        <div className={styles.scheduledDayContainer}>
          <div className={styles.dateHeader}>{header}</div>
          {children}
        </div>
      </>
    )
  },
)

export const ConsolidatedTimeSlot = observer(function ConsolidatedTimeSlot({
  startTime,
  endTime,
}: {
  startTime: string
  endTime: string
}) {
  return (
    <div className={styles.timeSlotCard}>
      <div className={styles.timeSlotText}>{`${startTime} - ${endTime}`}</div>
    </div>
  )
})
